// The words maternity and MCH records use (docs/plans/phase2-maternity-mch.md §2). Values
// are stored as these codes; labels are what screens say.

export const PREGNANCY_STATUSES = ['open', 'closed', 'entered_in_error'] as const;
export type PregnancyStatus = (typeof PREGNANCY_STATUSES)[number];

export const PREGNANCY_STATUS_LABELS: Readonly<Record<PregnancyStatus, string>> = {
  open: 'Open',
  closed: 'Closed',
  entered_in_error: 'Entered in error',
};

export const PREGNANCY_OUTCOMES = [
  'delivered',
  'pregnancy_loss',
  'transferred_out',
  'other',
] as const;
export type PregnancyOutcome = (typeof PREGNANCY_OUTCOMES)[number];

export const PREGNANCY_OUTCOME_LABELS: Readonly<Record<PregnancyOutcome, string>> = {
  delivered: 'Delivered',
  pregnancy_loss: 'Pregnancy loss',
  transferred_out: 'Care transferred elsewhere',
  other: 'Other',
};

/** Outcomes a person may choose when closing; "delivered" comes from the delivery record. */
export const PREGNANCY_CLOSE_OUTCOMES = ['pregnancy_loss', 'transferred_out', 'other'] as const;
export type PregnancyCloseOutcome = (typeof PREGNANCY_CLOSE_OUTCOMES)[number];

/** Every correctable maternity and MCH record: active, or entered in error with a reason (the shared record_status). */
export const MATERNITY_RECORD_STATUSES = ['active', 'entered_in_error'] as const;
export type MaternityRecordStatus = (typeof MATERNITY_RECORD_STATUSES)[number];

export const FETAL_MOVEMENTS = ['present', 'absent', 'not_assessed'] as const;
export type FetalMovement = (typeof FETAL_MOVEMENTS)[number];

export const FETAL_MOVEMENT_LABELS: Readonly<Record<FetalMovement, string>> = {
  present: 'Present',
  absent: 'Absent',
  not_assessed: 'Not assessed',
};

/** TODO(verify-spec) M15: align with the MOH 406 postnatal register. */
export const FEEDING_STATES = [
  'exclusive_breastfeeding',
  'mixed',
  'replacement',
  'not_assessed',
] as const;
export type FeedingState = (typeof FEEDING_STATES)[number];

export const FEEDING_LABELS: Readonly<Record<FeedingState, string>> = {
  exclusive_breastfeeding: 'Breastfeeding only',
  mixed: 'Mixed feeding',
  replacement: 'Replacement feeding',
  not_assessed: 'Not assessed',
};

export const POSTNATAL_SUBJECTS = ['mother', 'baby'] as const;
export type PostnatalSubject = (typeof POSTNATAL_SUBJECTS)[number];

/** Typing-error bounds (plan M7), not clinical limits. */
export const ANC_CONTACT_NUMBER_MAX = 20;
export const FUNDAL_HEIGHT_CM_MAX = 60;
export const MATERNITY_NOTE_MAX = 4000;
export const SHORT_TEXT_MAX = 120;
